(() => {
  'use strict';
  const galleries = new WeakMap();
  function photo(gallery, step) {
    let state = galleries.get(gallery);
    if (!state) {
      try { state = { images: JSON.parse(gallery.querySelector('[data-htl-photo-data]').textContent), index: 0 }; }
      catch (_) { return; }
      const first = gallery.querySelector('img.htl-catalog-card__image');
      if (first) {
        const path = new URL(first.currentSrc || first.src).pathname;
        const found = state.images.findIndex(image => new URL(image.src, location.href).pathname === path);
        if (found >= 0) state.index = found;
      }
      galleries.set(gallery, state);
    }
    if (state.images.length < 2) return;
    state.index = (state.index + step + state.images.length) % state.images.length;
    const image = gallery.querySelector('img.htl-catalog-card__image'), next = state.images[state.index];
    if (!image) return;
    image.removeAttribute('srcset'); image.removeAttribute('sizes');
    image.src = next.src; image.alt = next.alt;
    gallery.querySelector('[data-htl-photo-count]').textContent = `${state.index + 1} / ${state.images.length}`;
  }
  function updateRail(rail) {
    const track = rail.querySelector('[data-htl-track]');
    if (!track) return;
    const items = [...track.children].filter(node => !node.hidden);
    const bounds = track.getBoundingClientRect();
    const visible = items.map((node, index) => ({ rect: node.getBoundingClientRect(), index })).filter(({rect}) => Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left) > rect.width / 2);
    const first = visible.length ? visible[0].index + 1 : 0;
    const last = visible.length ? visible[visible.length - 1].index + 1 : 0;
    const counter = rail.querySelector('[data-htl-rail-status]');
    if (counter) {
      const template = first === last ? (counter.dataset.singleTemplate || '__FIRST__ / __TOTAL__') : (counter.dataset.rangeTemplate || '__FIRST__–__LAST__ / __TOTAL__');
      const label = template.replace('__FIRST__', first).replace('__LAST__', last).replace('__TOTAL__', items.length);
      if (counter.textContent !== label) counter.textContent = label;
    }
    const prev = rail.querySelector('[data-htl-rail-step="-1"]');
    const next = rail.querySelector('[data-htl-rail-step="1"]');
    if (prev) prev.disabled = track.scrollLeft < 2;
    if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
  }
  function scrollRail(track, direction) {
    const card = track.firstElementChild;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const stride = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    const pageSize = Math.max(1, Math.floor((track.clientWidth + gap + 2) / stride));
    track.scrollBy({ left: stride * pageSize * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  }
  document.addEventListener('keydown', event => {
    if (!event.target.matches('[data-htl-track]') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    scrollRail(event.target, event.key === 'ArrowRight' ? 1 : -1);
  });
  function init(root = document) {
    root.querySelectorAll('[data-htl-rail]').forEach(rail => {
      if (rail.dataset.ready) return;
      rail.dataset.ready = 'true';
      const track = rail.querySelector('[data-htl-track]');
      track.addEventListener('scroll', () => updateRail(rail), { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(() => updateRail(rail)).observe(track);
      updateRail(rail);
    });
  }
  document.addEventListener('click', event => {
    const arrow = event.target.closest('[data-htl-photo-step]');
    if (arrow) { event.preventDefault(); event.stopPropagation(); photo(arrow.closest('[data-htl-photo-gallery]'), Number(arrow.dataset.htlPhotoStep)); return; }
    const control = event.target.closest('[data-htl-rail-step]');
    if (control) {
      const rail = control.closest('[data-htl-rail]'), track = rail.querySelector('[data-htl-track]');
      scrollRail(track, Number(control.dataset.htlRailStep));
    }
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-htl-sort]')) return;
    const url = new URL(location.href); url.searchParams.set('sort_by', event.target.value); url.searchParams.delete('page'); location.assign(url.href);
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  init();
})();
